import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-video-modal-dialog',
    templateUrl: './video-modal-dialog.component.html',
    styleUrls: ['./video-modal-dialog.component.scss'],
    standalone: false
})
export class VideoModalDialogComponent {
  public url:SafeResourceUrl
  constructor(@Inject(MAT_DIALOG_DATA) public data: { videoUrl: string }, private sanitizer:DomSanitizer, public dialogRef: MatDialogRef<VideoModalDialogComponent>) {

    this.url =this.GetUrl();

   }

   public GetUrl():SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.data.videoUrl);
  }
  public closeModal(): void {
    this.dialogRef.close();
  }
}
